import React, { useState, useEffect, useRef ,useMemo} from 'react';
import { useSearchParams } from "react-router-dom";
import CreateAssetModal from './Createassetmodal';
import { useNavigate } from 'react-router-dom';
import Apis from '../services/apis';
import "../styles/clientHoldings.css";
import * as XLSX from "xlsx";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export default function ClientHoldings() {
  // State for client info
  const excelInputRef = useRef(null);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id") || localStorage.getItem("user_id");
  const name = searchParams.get("name") || localStorage.getItem("user_name");

  const [clientName, setClientName] = useState(id || 'John Doe');
  const navigate = useNavigate();
  const apis = new Apis();
  const [hoveredCategory, setHoveredCategory] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
  const [totalAssets, setTotalAssets] = useState(0);
  const [holdings, setHoldings] = useState([]);
  const [categorieslist,setCategoriesList]=useState([]);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [load,setLoad]=useState(true);
  const [addLoad,setAddLoad]=useState(false);
  const categories = React.useMemo(() => {
    const grouped = {};
    let totalValue = 0;
  
    holdings.forEach(h => {
      const value = Number(h.value) || 0;
      totalValue += value;
  
      if (!grouped[h.category]) {
        grouped[h.category] = {
          name: h.category,
          color: h.categoryColor,
          totalValue: 0,
          count: 0,
        };
      }
  
      grouped[h.category].totalValue += value;
      grouped[h.category].count += 1;
    });
  
    let res =  Object.values(grouped).map(cat => ({
      name: cat.name,
      color: cat.color,
      value: cat.totalValue,
      count: cat.count,
      percentage: totalValue
        ? Number(((cat.totalValue / totalValue) * 100).toFixed(2))
        : 0,
    }));
    res.sort((a, b) => b.percentage - a.percentage);
    return res;
  }, [holdings]);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    getCategories()
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  const getCategories = () => {
    apis.getCategories()
    .then((response) => {
        let data = response.data
        setCategoriesList(data)
        // setLoad(false)
        getHoldings()
    })
    .catch((error) => {
        if (error.response && error.response.status === 404) {
            setLoad(false)
            alert("Error occurred while fetching categories "+ error.response.data.message);
        } else {
            // Handle other errors
            console.error("Error:", error);
            alert("Error occurred while fetching asset data");
        }
    });
  }

  function calculatePercentageChange(
    acquiredPrice,
    currentValue
  ){
    const acquired = Number(acquiredPrice);
    const current = Number(currentValue);
  
    if (!acquired || isNaN(acquired) || isNaN(current)) {
      return 0;
    }
  
    const change = ((current - acquired) / acquired) * 100;
  
    // round to 2 decimals
    return Number(change.toFixed(2));
  }

  const getHoldings = () => {
    apis.getHoldings(id)
    .then((response) => {
        let data = response.data
        console.log("holdings data:", data);
        let arr = [];
        data.forEach((item)=>{

          let itemx = item.images.find(img => img.isPrimary);
          console.log("Primary image:", itemx?.imageUrl);
          arr.push({
            id: item.id,
            name: item.asset.name,
            location: item.asset.metadata?.locationName || '-',
            description: item.asset.subtitle,
            category: item.asset.category.label,
            categoryColor: item.asset.category.color,
            primary:itemx?.imageUrl,
            value: item.currentValue,
            change:
            item.acquiredPrice != null && item.currentValue != null
              ? calculatePercentageChange(item.acquiredPrice, item.currentValue)
              : null,
            icon: item.asset.category.icon,
            appraisedPrice: item.asset.metadata?.appraisedPrice,
            appraisedDate: item.asset.metadata?.appraisedDate,
            acquiredDate: item.acquiredDate,
            acquiredPrice: item.acquiredPrice,
          })
        })
        setHoldings(arr);
        let total = 0;
        arr.map((item) => {
          let val =  Number(item.value) || 0;
          total = total + val;
        });
        console.log("Total assets:", total);
        setTotalAssets(total);
        // setCategoriesList(data)
        setLoad(false)
    })
    .catch((error) => {
        if (error.response && error.response.status === 404) {
            setLoad(false)
            alert("Error occurred while fetching categories "+ error.response.data.message);
        } else {
            // Handle other errors
            console.error("Error:", error);
            alert("Error occurred while fetching asset data");
        }
    });
  }

  const formatCurrency = (value) => {
    const num = Number(value);
  
    const format = (n) =>
      Number(n.toPrecision(4)).toString(); // removes extra zeros
  
    if (num >= 1_000_000_000_000) {
      return `$${format(num / 1_000_000_000_000)}T`;
    }
    if (num >= 1_000_000_000) {
      return `$${format(num / 1_000_000_000)}B`;
    }
    if (num >= 1_000_000) {
      return `$${format(num / 1_000_000)}M`;
    }
    if (num >= 1_000) {
      return `$${format(num / 1_000)}K`;
    }
    return `$${num.toLocaleString()}`;
  };
  
  const formatPercentage = (value) => {
    return value > 0 ? `+${value}%` : `${value}%`;
  };

  const [sortConfig, setSortConfig] = React.useState({
    key: 'change',
    direction: 'desc',
  });
  
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === 'asc' ? 'desc' : 'asc',
        };
      }
      return { key, direction: 'asc' };
    });
  };

  const sortableThStyle = {
    cursor: 'pointer',
    userSelect: 'none',
  };

  const handleCreateAsset = async (formData) => {
    try {
      setAddLoad(true);
  
      /* ===============================
         1️⃣ CREATE ASSET
      =============================== */
      const assetRes = await fetch(
        "https://schedulerapi.pricingculture.com/holdings/assets",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: formData.name,
            subtitle: formData.subtitle,
            categoryId: formData.categoryId,
            metadata: formData.metadata,
          }),
        }
      );
  
      if (!assetRes.ok) throw new Error("Failed to create asset");
  
      const asset = await assetRes.json();
      const assetId = asset.id;
  
      /* ===============================
         2️⃣ S3 UPLOAD HELPER
      =============================== */
      const uploadToS3 = async (file) => {
        const uniqueFileName = `${Date.now()}-${file.name}`;
  
        const presignedRes = await fetch(
          `https://schedulerapi.pricingculture.com/holdings/generate-presigned-url?fileName=${encodeURIComponent(
            uniqueFileName
          )}&fileType=${file.type}`
        );
  
        const { uploadUrl } = await presignedRes.json();
  
        await fetch(uploadUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type },
          body: file,
        });
  
        return `https://pc-holding-document-bucket.s3.us-east-2.amazonaws.com/${uniqueFileName}`;
      };
  
      /* ===============================
         3️⃣ UPLOAD FILES (ONCE)
      =============================== */
      const images = [];
      for (const file of formData.images || []) {
        const imageUrl = await uploadToS3(file);
        images.push({
          imageUrl,
          caption: file.name,
          isPrimary: false,
        });
      }
  
      const documents = [];
      for (const file of formData.documents || []) {
        const documentUrl = await uploadToS3(file);
        documents.push({
          name: file.name,
          fileUrl: documentUrl,
          fileType: file.type,
          sizeKb: Math.round(file.size / 1024),
        });
      }
  
      /* ===============================
         4️⃣ CREATE HOLDING
      =============================== */
      const holdingRes = await fetch(
        "https://schedulerapi.pricingculture.com/holdings/",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            clientAccountId: id,
            assetId: assetId,
            acquiredDate: new Date(formData.acquiredDate),
            acquiredPrice: formData.acquiredPrice,
            currentValue: formData.currentValue,
            currency: "USD",
            images,
            documents,
          }),
        }
      );
  
      if (!holdingRes.ok) throw new Error("Failed to create holding");
  
      const holding = await holdingRes.json();
      console.log("Asset:", asset);
      console.log("Holding:", holding);

      alert("Asset & Holding created successfully!");
      setIsCreateModalOpen(false);
      getHoldings();
    } catch (err) {
      console.error("Creation failed", err);
      alert("Failed to create asset or holding");
    } finally {
      setAddLoad(false);
    }
  };

  const handleExcelUploadClick = () => {
    if (!categorieslist.length) {
      alert("Categories are still loading. Please wait.");
      return;
    }
    excelInputRef.current.click();
  };

  const handleExcelFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    try {
      await importAssetsFromExcel(file);
      alert("Excel import completed successfully");
      getHoldings();
    } catch (err) {
      console.error(err);
      alert("Excel import failed");
    } finally {
      e.target.value = null; // reset input
    }
  };

  const importAssetsFromExcel = async (excelFile) => {
    setAddLoad(true);
  
    try {
      const buffer = await excelFile.arrayBuffer();
      const workbook = XLSX.read(buffer);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet);
  
      if (!rows.length) {
        alert("Excel file is empty");
        return;
      }
  
      for (const row of rows) {
        /* ---------- Resolve Category ---------- */
        const category = categorieslist.find(
          (c) =>
            c.label?.toLowerCase().trim() ===
            row["Asset Category"]?.toLowerCase().trim()
        );
  
        if (!category) {
          console.warn("Skipping row. Category not found:", row["Asset Category"]);
          continue;
        }
  
        /* ---------- Create Asset ---------- */
        const assetRes = await fetch(
          "https://schedulerapi.pricingculture.com/holdings/assets",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              name: row["Asset Name"],
              subtitle: row["Asset Description"],
              categoryId: category.id,
              metadata: {
                notes: row["Notes"],
                locationName: row["Location Name"],
                locationDetails: row["Location Details"],
                maintenanceCost: Number(row["Maintenance Cost"]),
                acquisitionPriceType: row["Acquisition Price Type"],
                appraisedPrice: Number(row["Appraised Price"]),
                appraisedDate: row["Appraised Date"],
                indicativePrice:row["Indicative Price"],
              },
            }),
          }
        );
  
        if (!assetRes.ok) throw new Error("Asset creation failed");
        const asset = await assetRes.json();

        const acquisitionPrice = Number(row["Acquisition Price"]) || 0;
        const appraisedPrice = Number(row["Appraised Price"]) || 0;

        const currentValue = appraisedPrice > 0 
          ? appraisedPrice 
          : acquisitionPrice;
  
        /* ---------- Create Holding ---------- */
        const holdingRes = await fetch(
          "https://schedulerapi.pricingculture.com/holdings/",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              clientAccountId: id,
              assetId: asset.id,
              acquiredDate: row["Acquisition Date"]?new Date(row["Acquisition Price"]):null,
              acquiredPrice: Number(row["Acquisition Price"]),
              currentValue: currentValue,
              currency: "USD",
              images: [],
              documents: [],
            }),
          }
        );
  
        if (!holdingRes.ok) throw new Error("Holding creation failed");
      }
    } finally {
      setAddLoad(false);
    }
  };
  
  

  const [filters, setFilters] = useState({
    category: 'All Asset Class',
    location: 'All Location',
  });

  const categoryOptions = React.useMemo(() => {
    const set = new Set(holdings.map(h => h.category).filter(Boolean));
    return ['All Asset Class', ...Array.from(set)];
  }, [holdings]);
  
  const locationOptions = React.useMemo(() => {
    const set = new Set(holdings.map(h => h.location).filter(Boolean));
    return ['All Location', ...Array.from(set)];
  }, [holdings]);

  const filteredHoldings = useMemo(() => {
    return holdings.filter(h => {
      const categoryOk =
        filters.category.toLowerCase() === 'all asset class' || h.category === filters.category;
  
      const locationOk =
        filters.location.toLowerCase() === 'all location' || h.location === filters.location;
  
      return categoryOk && locationOk;
    });
  }, [holdings, filters]);
  
  const sortedHoldings = React.useMemo(() => {
    if (!sortConfig.key) return filteredHoldings;
  
    return [...filteredHoldings].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
  
      if (aVal == null) return 1;
      if (bVal == null) return -1;
  
      if (typeof aVal === 'number') {
        return sortConfig.direction === 'asc'
          ? aVal - bVal
          : bVal - aVal;
      }
  
      return sortConfig.direction === 'asc'
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
  }, [filteredHoldings, sortConfig]);

  const adjustColor = (hex, amount) => {
    let col = hex.replace('#', '');
    if (col.length === 3) {
      col = col.split('').map(c => c + c).join('');
    }
  
    const num = parseInt(col, 16);
  
    const r = Math.min(255, Math.max(0, (num >> 16) + amount));
    const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + amount));
    const b = Math.min(255, Math.max(0, (num & 0x0000ff) + amount));
  
    return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
  };


  
  const [activeIndex, setActiveIndex] = React.useState(null);
  const [selectedCategory, setSelectedCategory] = React.useState(null);

  const categoryPieData = useMemo(() => {
    const map = {};
  
    filteredHoldings.forEach(h => {
      if (!map[h.category]) {
        map[h.category] = {
          name: h.category,
          value: 0,
          color: h.categoryColor,
        };
      }
      map[h.category].value += Number(h.value);
    });
  
    return Object.values(map);
  }, [filteredHoldings]);
  
  
  const drillDownPieData = useMemo(() => {
    if (!selectedCategory) return [];
  
    return filteredHoldings
      .filter(h => h.category === selectedCategory)
      .map(h => ({
        name: h.name,
        value: Number(h.value),
        color: h.categoryColor,
      }));
  }, [selectedCategory, filteredHoldings]);
  

  
  const pieData = selectedCategory
    ? drillDownPieData
    : categoryPieData;

    
  
  const pieTotal = pieData.reduce((s, d) => s + d.value, 0);

  const getPieIndexByName = (name) => {
    return pieData.findIndex(d => d.name === name);
  };
  
  // Mobile Layout
  if (!load && window.innerWidth < 768 && false) {
    return (
      <div style={{
        backgroundColor: '#0a0a0a',
        color: '#e5e5e5',
        minHeight: '100vh',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        padding: '16px',
        // maxWidth: '450px',
        margin: '0 auto'
      }}>

  
        {/* Client Name */}
        <div style={{
          border: '1px solid #ff9f1c',
          borderRadius: '8px',
          padding: '12px 16px',
          marginBottom: '16px',
          background: '#1a1208'
        }}>
          <div style={{
            fontSize: '10px',
            color: '#ff9f1c',
            marginBottom: '4px',
            letterSpacing: '1px'
          }}>CLIENT</div>
          <div style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#fff'
          }}>{clientName}</div>
        </div>

        {/* Total Assets Card */}
        <div style={{
          border: '1px solid #2a2a2a',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '16px',
          backgroundColor: '#0d0d0d',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '36px',
            fontWeight: '700',
            color: '#ff9f1c',
            marginBottom: '8px'
          }}>{formatCurrency(totalAssets)}</div>
          <div style={{
            fontSize: '11px',
            color: '#666',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            marginBottom: '24px'
          }}>TOTAL ASSETS</div>

          {/* Horizontal Bar Chart */}
          <div style={{
            height: '8px',
            backgroundColor: '#1a1a1a',
            borderRadius: '4px',
            overflow: 'hidden',
            display: 'flex',
            marginBottom: '16px'
          }}>
            <div style={{
              width: '83%',
              backgroundColor: '#ff2d55',
              transition: 'all 0.3s ease'
            }} />
            <div style={{
              width: '6%',
              backgroundColor: '#8b5cf6',
              transition: 'all 0.3s ease'
            }} />
            <div style={{
              width: '5%',
              backgroundColor: '#ff9f1c',
              transition: 'all 0.3s ease'
            }} />
            <div style={{
              width: '1%',
              backgroundColor: '#06b6d4',
              transition: 'all 0.3s ease'
            }} />
          </div>

          {/* Legend */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '16px',
            flexWrap: 'wrap',
            fontSize: '12px'
          }}>
            {categories.map((cat, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <div style={{
                  width: '8px',
                  height: '8px',
                  backgroundColor: cat.color,
                  borderRadius: '2px'
                }} />
                <span style={{ color: '#aaa' }}>{cat.name} {cat.percentage}%</span>
              </div>
            ))}
          </div>
        </div>

        {/* Holdings List */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          {holdings.map((holding) => (
            <div
              key={holding.id}
              style={{
                border: '1px solid #1a1a1a',
                borderRadius: '12px',
                padding: '16px',
                backgroundColor: '#0d0d0d',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onClick={() => console.log('View holding', holding.id)}
            >
              {/* <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '10px',
                backgroundColor: '#1a1a1a',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                flexShrink: 0
              }}>{holding.icon}</div> */}
              
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontSize: '15px',
                  fontWeight: '600',
                  marginBottom: '4px',
                  color: '#fff'
                }}>{holding.name}</div>
                <div style={{
                  fontSize: '12px',
                  color: '#666',
                  maxWidth: '250px',
                }}>{holding.description}</div>
                   <div style={{
                  fontSize: '13px',
                  fontWeight: '600',
                  marginTop: '10px',
                  color: '#fff',
                  opacity:0.8
                }}>📍 {holding.location}</div>
                <div
                className="category-badge"
                style={{
                  marginTop:'15px',
                  // backgroundColor: `#141414`,
                  // backgroundColor: `rgba(255, 255, 255, 0.1)`,
                  backgroundColor: `${holding.categoryColor}22`,
                  color: holding.categoryColor,
                  borderColor: `${holding.categoryColor}`
                }}
              >
                {holding.icon && (
                  <img src={holding.icon} alt="" className="category-icon" 
                  style={{
                    marginTop:'2px',
                    filter: "brightness(0) invert(1)"

                  }}
                  />
                )}
                <span style={{color:`${holding.categoryColor}`}}>{holding.category}</span>
              </div>
           
              </div>
              

              <div style={{
                textAlign: 'right',
                flexShrink: 0
              }}>
                <div style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  marginBottom: '4px',
                  color: '#fff'
                }}>{formatCurrency(holding.value)}</div>
                <div style={{
                  fontSize: '13px',
                  fontWeight: '600',
                  color: holding.change > 0 ? '#4ade80' : '#f87171'
                }}>{formatPercentage(holding.change)}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Enterprise Ready Footer */}
        {/* <div style={{
          marginTop: '40px',
          textAlign: 'center',
          paddingBottom: '24px'
        }}>
          <div style={{
            fontSize: '11px',
            color: '#ff9f1c',
            letterSpacing: '2px',
            fontWeight: '600',
            marginBottom: '16px'
          }}>ENTERPRISE READY</div>
          <div style={{
            fontSize: '14px',
            color: '#666',
            lineHeight: '1.6'
          }}>
            We support single family and multi-family offices managing collections
          </div>
        </div> */}
      </div>
    );
  }

  

  // Desktop Layout (existing code)
  if (load) {
    return (
      <div style={{
        height: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '10px solid rgba(255,255,255,0.2)',
            borderTop: '10px solid #F4A31E',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}
        />
      </div>
    );
  }
  if (addLoad) {
    return (
      <div style={{
        height: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '10px solid rgba(255,255,255,0.2)',
            borderTop: '10px solid #F4A31E',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginRight: '30px'
          }}
        /> Uploading excel Please wait...
      </div>
    );
  }

  else
  {
      return (
      <div style={{
        backgroundColor: '#0a0a0a',
        color: '#e5e5e5',
        // minHeight: '100vh',
        height:'100%',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        padding: '24px'
      }}>

    <CreateAssetModal  
      isOpen={isCreateModalOpen} 
      onClose={()=>{setIsCreateModalOpen(false)}} 
      categories={categorieslist} 
      onSubmit={(data)=>handleCreateAsset(data)}
      loading={addLoad}   
      error={null} 
    />

        {/* Header */}
        <div style={{
          border: '1px solid #3a2810',
          padding: '12px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          background: 'linear-gradient(90deg, #1a1208 0%, #0a0a0a 100%)',
          marginBottom: '32px',
          borderRadius: '6px',
        }}>
          <span style={{
            color: '#997547',
            fontSize: '11px',
            fontWeight: '500',
            letterSpacing: '0.5px',
            marginTop:4
          }}>VIEWING</span>
          <strong style={{ fontSize:  window.innerWidth > 768?'15px':'12px' }}>{name} ({id})</strong>
          <div style={{display:'flex', marginLeft:'auto'}}>
         { window.innerWidth > 768 &&( <button 
            onClick={() => setIsCreateModalOpen(true)}
            style={{
              marginLeft: 'auto',
              background: 'none',
              border: 'none',
              color: '#997547',
              cursor: 'pointer',
              fontSize: '13px',
              border:'1px solid #997547',
              padding:'10px',
              borderRadius:12,
              backgroundColor:"#000"
            }}
          >
            + Add Asset
          </button>
          )}
          { window.innerWidth > 768&&(<button
            onClick={handleExcelUploadClick}
            style={{
              marginLeft: '20px',
              background: 'none',
              border: '1px solid #997547',
              color: '#997547',
              cursor: 'pointer',
              fontSize: '13px',
              padding: '10px',
              borderRadius: 12,
              backgroundColor: '#000',
            }}
          >
            + Upload Excel
          </button>)}

          <input
            type="file"
            accept=".xlsx,.xls"
            ref={excelInputRef}
            style={{ display: 'none' }}
            onChange={handleExcelFileChange}
          />
          </div>
        </div>

        {/* Title Row */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px'
        }}>
          <h2 style={{ 
            fontSize: '20px', 
            fontWeight: '600',
            margin: 0 
          }}>Client Holdings</h2>
          {/* <div style={{ display: 'flex', gap: '8px' }}>
            <button 
              onClick={() => console.log('Add holding')}
              style={{
                background: '#111',
                border: '1px solid #2a2a2a',
                color: '#888',
                width: '36px',
                height: '36px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '18px'
              }}
            >+</button>
            <button 
              onClick={() => console.log('Upload')}
              style={{
                background: '#111',
                border: '1px solid #2a2a2a',
                color: '#888',
                width: '36px',
                height: '36px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '18px'
              }}
            >⇧</button>
          </div> */}
        </div>

        {/* Content */}
        <div style={{
          display: 'flex',
          gap: '24px',
          alignItems: 'flex-start',
          ...(window.innerWidth < 768 && {
            flexWrap:'wrap'
          })
        }}>
          
          <div style={{
            minWidth:  window.innerWidth < 768 ? '100%':'300px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <ResponsiveContainer width="100%" height={320}>
              <PieChart>

                {/* ===== Gradients ===== */}
                <defs>
                  {pieData.map((entry, index) => (
                    <linearGradient
                      key={index}
                      id={`pie-grad-${index}`}
                      x1="0"
                      y1="0"
                      x2="1"
                      y2="1"
                    >
                      <stop offset="0%" stopColor={adjustColor(entry.color, 35)} />
                      <stop offset="100%" stopColor={adjustColor(entry.color, -35)} />
                    </linearGradient>
                  ))}
                </defs>

                {/* ===== Pie ===== */}
                <Pie
                  data={pieData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={72}
                  outerRadius={120}
                  paddingAngle={3}
                  cornerRadius={8}
                  activeIndex={activeIndex}
                  activeOuterRadius={134}
                  onMouseEnter={(_, index) => setActiveIndex(index)}
                  onMouseLeave={() => setActiveIndex(null)}
                  onClick={(_, index) => {
                    // if (!selectedCategory) {
                    //   setSelectedCategory(pieData[index].name);
                    //   setActiveIndex(null);
                    // }
                  }}
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={index}
                      fill={`url(#pie-grad-${index})`}
                      opacity={
                        activeIndex === null || activeIndex === index ? 1 : 0.3
                      }
                      stroke="#020617"
                      strokeWidth={1}
                    />
                  ))}
                </Pie>

                {/* ===== CENTER TEXT ===== */}
                {activeIndex !== null ? (
                  <>
                    <text
                      x="50%"
                      y="46%"
                      textAnchor="middle"
                      fill="#fff"
                      fontSize={18}
                      fontWeight={700}
                    >
                      {formatCurrency(pieData[activeIndex].value)}
                    </text>
                    <text
                      x="50%"
                      y="54%"
                      textAnchor="middle"
                      fill="#94a3b8"
                      fontSize={12}
                      letterSpacing="0.08em"
                    >
                      {pieData[activeIndex].name.toUpperCase()}
                    </text>
                  </>
                ) : (
                  <>
                    <text
                      x="50%"
                      y="46%"
                      textAnchor="middle"
                      fill="#fff"
                      fontSize={18}
                      fontWeight={700}
                    >
                      {formatCurrency(pieTotal)}
                    </text>
                    <text
                      x="50%"
                      y="54%"
                      textAnchor="middle"
                      fill="#64748b"
                      fontSize={12}
                      letterSpacing="0.08em"
                    >
                      {selectedCategory
                        ? selectedCategory.toUpperCase()
                        : 'TOTAL ASSETS'}
                    </text>
                  </>
                )}

                {/* ===== Tooltip ===== */}
                {/* <Tooltip
                  formatter={(value, name) => [
                    `$${Number(value).toLocaleString()}`,
                    name,
                  ]}
                  cursor={false}
                  contentStyle={{
                    backgroundColor: '#020617',
                    border: '1px solid #1e293b',
                    borderRadius: '8px',
                    color: '#fff',
                  }}
                /> */}
              </PieChart>
            </ResponsiveContainer>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              marginTop: '32px',
              fontSize: '13px',
              width: '100%'
            }}>
              {categories.map((cat, index) => (
                <li 
                  key={index} 
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '12px',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    transition: 'background-color 0.2s ease',
                    backgroundColor: hoveredCategory === cat.name ? '#1a1a1a' : 'transparent'
                  }}
                  onMouseEnter={() => {
                    setHoveredCategory(cat.name)
                    const pieIndex = getPieIndexByName(cat.name);
                    setActiveIndex(pieIndex !== -1 ? pieIndex : null);
                  }}
                  onMouseLeave={() => {
                    setHoveredCategory(null)
                    setActiveIndex(null);
                  }}
                  onClick={()=>{
                    setFilters(f => ({ ...f, category: cat.name }));
                    setSelectedCategory(cat.name)
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{
                      width: '12px',
                      height: '12px',
                      borderRadius: '2px',
                      backgroundColor: cat.color,
                      display: 'inline-block',
                      transition: 'transform 0.2s ease',
                      transform: hoveredCategory === cat.name ? 'scale(1.2)' : 'scale(1)'
                    }} />
                    <span style={{ 
                      color: hoveredCategory === cat.name ? '#fff' : '#aaa',
                      transition: 'color 0.2s ease'
                    }}>{cat.name}</span>
                  </div>
                  <span style={{ 
                    color: hoveredCategory === cat.name ? '#fff' : '#666',
                    transition: 'color 0.2s ease'
                  }}>{cat.percentage}%</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
              <div className="filters">
                <select
                  value={filters.category}
                  onChange={(e) => {
                    const value = e.target.value;

                    setFilters(f => ({ ...f, category: value }));
                    setActiveIndex(null);
                    if (value === 'All Asset Class') {
                      setSelectedCategory(null);       // reset pie
                    } else {
                      setSelectedCategory(value);      // drill down
                    }
                  }}
                >
                  {categoryOptions.map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>

                <select
                  value={filters.location}
                  onChange={(e) => {
                    setFilters(f => ({ ...f, location: e.target.value }));
                    setActiveIndex(null);
                  }}
                >
                  {locationOptions.map(loc => (
                    <option key={loc} value={loc}>{loc}</option>
                  ))}
                </select>
              </div>
              <div
                style={{
                  flex: 1,
                  border: '1px solid #1f1f1f',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  backgroundColor: '#0d0d0d',
                  ...(window.innerWidth > 768 && {
                    overflowY: 'auto',
                    maxHeight: '70vh',
                  }),
                }}
              >
               { window.innerWidth > 1100 && ( <table style={{
                  width: '100%',
                  borderCollapse: 'collapse'
                }}>
                  
                  <thead>
                    <tr style={{ backgroundColor: '#0a0a0a' }}>
                      <th style={{ padding: '16px', width: '120px', color:'grey',paddingLeft:30}}>#</th>
                        
                      <th
                        onClick={() => handleSort('name')}
                        style={{ ...sortableThStyle, textAlign: 'left', padding: '16px 20px', fontSize: '11px', color: '#666', textTransform: 'uppercase' }}
                      >
                        Asset
                        <span style={{ marginLeft: '10px', fontSize: '10px' }}>
                          {sortConfig.key === 'name'? sortConfig.direction === 'asc' ? '▲' : '▼': '▲'}
                        </span>
                      </th>

                      <th
                        onClick={() => handleSort('category')}
                        style={{ ...sortableThStyle, textAlign: 'left', padding: '16px 20px', fontSize: '11px', color: '#666', textTransform: 'uppercase' }}
                      >
                        Asset Class
                        <span style={{ marginLeft: '10px', fontSize: '10px' }}>
                          {sortConfig.key === 'category'? sortConfig.direction === 'asc' ? '▲' : '▼': '▲'}
                        </span>
                      </th>
                      <th
                        onClick={() => handleSort('location')}
                        style={{ ...sortableThStyle, textAlign: 'left', padding: '16px 20px', fontSize: '11px', color: '#666', textTransform: 'uppercase' }}
                      >
                        Location
                        <span style={{ marginLeft: '10px', fontSize: '10px' }}>
                          {sortConfig.key === 'location'? sortConfig.direction === 'asc' ? '▲' : '▼': '▲'}
                        </span>
                      </th>
                      <th
                        onClick={() => handleSort('value')}
                        style={{ ...sortableThStyle, textAlign: 'right', padding: '16px 20px', fontSize: '11px', color: '#666', textTransform: 'uppercase' }}
                      >
                        Value
                        <span style={{ marginLeft: '10px', fontSize: '10px' }}>
                          {sortConfig.key === 'value'? sortConfig.direction === 'asc' ? '▲' : '▼': '▲'}
                        </span>
                      </th>
                      

                      <th
                        onClick={() => handleSort('change')}
                        style={{ ...sortableThStyle, textAlign: 'right', padding: '16px 20px', fontSize: '11px', color: '#666', textTransform: 'uppercase' }}
                      >
                        Change
                        <span style={{ marginLeft: '10px', fontSize: '10px' }}>
                          {sortConfig.key === 'change'? sortConfig.direction === 'asc' ? '▲' : '▼': '▲'}
                        </span>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {sortedHoldings.map((holding) => {
                      // Find the matching category name
                      const categoryName = categories.find(cat => 
                        cat.color === holding.categoryColor
                      )?.name;
                      
                      return (
                        <tr 
                        onClick={() => navigate('/client-holdings/details?id='+holding.id)}

                          key={holding.id} 
                          style={{ 
                            borderTop: '1px solid #1a1a1a',
                            backgroundColor: hoveredCategory === categoryName ? '#141414' : 'transparent',
                            transition: 'background-color 0.2s ease',
                            cursor: 'pointer',
                            
                          }}
                          onMouseEnter={() => setHoveredCategory(categoryName)}
                          onMouseLeave={() => setHoveredCategory(null)}
                        >
                          <td style={{ padding: '20px' }}>
                            {holding.icon && (
                              <img
                                src={holding.primary?holding.primary:holding.icon}
                                alt=""
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  borderRadius: '8px',
                                  objectFit: 'cover',
                                  border:'1px solid #1a1a1a',
                                  // filter: 'brightness(0) invert(1)',
                                }}
                              />
                            )}
                          </td>
                          <td style={{ padding: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px',maxWidth:'320px' }}>
                              <div>
                                <div style={{ 
                                  fontWeight: '500',
                                  marginBottom: '4px',
                                  fontSize: '14px'
                                }}>{holding.name}</div>
                                <div style={{ 
                                  fontSize: '12px', 
                                  color: '#666'
                                }}>{holding.description}</div>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: '20px' }}>
              
                            <div
                              className="category-badge"
                              style={{
                                marginTop:'15px',
                                // backgroundColor: `#141414`,
                                // backgroundColor: `rgba(255, 255, 255, 0.1)`,
                                backgroundColor: `${holding.categoryColor}22`,
                                color: holding.categoryColor,
                                borderColor: `${holding.categoryColor}`
                              }}
                            >
                              {/* {holding.icon && (
                                <img src={holding.icon} alt="" className="category-icon" 
                                style={{
                                  marginRight:'8px',
                                  filter: "brightness(0) invert(1)"

                                }}
                                />
                              )} */}
                              <span style={{color:`${holding.categoryColor}`}}>{holding.category}</span>
                            </div>
                          </td>

                          <td style={{ 
                            padding: '20px', 
                            textAlign: 'left',
                            fontSize: '14px',
                            fontWeight: '500'
                          }}>{(holding.location)}</td>

                          <td style={{ 
                            padding: '20px', 
                            textAlign: 'right',
                            fontSize: '14px',
                            fontWeight: '500'
                          }}>{formatCurrency(holding.value)}</td>
                        
                        {/* <td
                            title={`Acquired Price: ${holding.acquiredPrice} Acquired Date: ${holding.acquiredDate}  Appraised Price: ${holding.appraisedPrice?holding.appraisedPrice:'-'} Appraised Date: ${holding.appraisedDate?holding.appraisedDate:'-'}`}
                            style={{ 
                              padding: '20px', 
                              textAlign: 'right',
                              color: holding.change >= 0 ? '#4ade80' : '#f87171',
                              fontSize: '14px',
                              fontWeight: '500'
                            }}
                          >
                          {holding.appraisedPrice?formatPercentage(holding.change):'-'}
                          {formatPercentage(holding.change)} 
                        </td> */}

                          <td
                            style={{ 
                              padding: '20px', 
                              textAlign: 'right',
                              color: holding.change >= 0 ? '#4ade80' : '#f87171',
                              fontSize: '14px',
                              fontWeight: '500',
                              position: 'relative'
                            }}
                          >
                            <span className="tooltip-wrapper">
                              {holding.appraisedPrice ? formatPercentage(holding.change) : '-'}

                              <div className="tooltip-box">
                                <div className="tooltip-row">
                                  <span>Acquired Price</span>
                                  <span>{formatCurrency(holding.acquiredPrice)}</span>
                                </div>

                                <div className="tooltip-row">
                                  <span>Acquired Date</span>
                                  <span>{holding.acquiredDate?.split("T")[0] || "-"}</span>
                                </div>

                                <div className="tooltip-divider" />

                                <div className="tooltip-row">
                                  <span>Appraised Price</span>
                                  <span>
                                    {holding.appraisedPrice
                                      ? formatCurrency(holding.appraisedPrice)
                                      : '-'}
                                  </span>
                                </div>

                                <div className="tooltip-row">
                                  <span>Appraised Date</span>
                                  <span>{holding.appraisedDate || '-'}</span>
                                </div>
                              </div>
                            </span>
                          </td>

                        </tr>
                      );
                    })}
                  </tbody>
                </table>)}

                {window.innerWidth < 1100 && sortedHoldings.map((holding) => (
                  <div
                    key={holding.id}
                    style={{
                      border: '1px solid #1a1a1a',
                      borderRadius: '12px',
                      padding: '16px',
                      backgroundColor: '#0d0d0d',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    // onClick={() => console.log('View holding', holding.id)}
                    onClick={() => navigate('/client-holdings/details?id='+holding.id)}
                  >
                    {/* <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '10px',
                      backgroundColor: '#1a1a1a',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '24px',
                      flexShrink: 0
                    }}>{holding.icon}</div> */}
                    
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{
                        fontSize: '15px',
                        fontWeight: '600',
                        marginBottom: '4px',
                        color: '#fff'
                      }}>{holding.name}</div>
                      <div style={{
                        fontSize: '12px',
                        color: '#666',
                        maxWidth: '250px',
                      }}>{holding.description}</div>
                        <div style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        marginTop: '10px',
                        color: '#fff',
                        opacity:0.8
                      }}>📍 {holding.location}</div>
                      <div
                      className="category-badge"
                      style={{
                        marginTop:'15px',
                        // backgroundColor: `#141414`,
                        // backgroundColor: `rgba(255, 255, 255, 0.1)`,
                        backgroundColor: `${holding.categoryColor}22`,
                        color: holding.categoryColor,
                        borderColor: `${holding.categoryColor}`
                      }}
                    >
                      {/* {holding.icon && (
                        <img src={holding.icon} alt="" className="category-icon" 
                        style={{
                          marginTop:'2px',
                          filter: "brightness(0) invert(1)"

                        }}
                        />
                      )} */}
                      <span style={{color:`${holding.categoryColor}`}}>{holding.category}</span>
                    </div>
                
                    </div>
                    

                    <div style={{
                      textAlign: 'right',
                      flexShrink: 0
                    }}>
                      <div style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        marginBottom: '4px',
                        color: '#fff'
                      }}>{formatCurrency(holding.value)}</div>
                      <div style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        color: holding.change > 0 ? '#4ade80' : '#f87171'
                      }}>{formatPercentage(holding.change)}</div>
                    </div>
                  </div>
                ))}

              </div>
          </div>
          
        </div>
      </div>
    );
  }
}